module.exports = __webpack_public_path__ + "static/media/spray_gun.adb9ee42.svg";